export default "__VITE_ASSET__559942fd__"